import React from "react";
import "../css/questions.css"

export const QuestionsBanner = () => {
  return (
    <div className="container">
      <div className="banner-container">
        <div className="banner-img">
          <img
            className="desktop-view"
            src="/assets/questionsbanner.webp"
            alt="banner"
          />
          <img
            className="mobile-view"
            src="/assets/questionsbannermob.webp"
            alt="banner"
          />
        </div>
      </div>
    </div>
  );
};

export const Questions = () => {
    const faqData = [
        {
          question: "When should I contact CLA to engage your services?",
          answer:
            "As soon as possible once you understand the parameters of your engagement and how we can service your needs.",
        },
        {
          question: "How do I engage CLA?",
          answer: "Please use the “Contact Us” section of the website to connect with us, after which we will respond promptly.",
        },
        {
          question: "Are your lease abstracts and reports customizable?",
          answer: "Yes!  CLA will work with each client to understand the specific areas of focus and tailor the deliverables accordingly.",
        },
        {
            question: "How in-depth do you look at tenant reimbursements for an ARGUS review?",
            answer: "We prepare a trifold review, which includes a comparison of the reimbursement lease terms to the Argus model as well as the property reimbursement reconciliations. Any differences are noted in our report.",
          },
          {
            question: "What type of procedures do you perform for an NOI analysis?",
            answer: "We typically perform 10 to 15 financial procedures, which are tailored to client needs. Standard procedures include, but are not limited to, the following: historical financial statements, rent roll, RE taxes, accounts receivable, accounts payable, cash receipts, bank statements, service contracts, capital expenditures, and management agreements."
          },
      ];
  return (
    <div className="container">
      <div className="heading-page">
        <h1 className="home-heading">
          <img src="/assets/icons/flag.svg" alt="" />
          <span className="heading-red">COMMONLY ASKED</span>
          <br />
        </h1>
        <span className="heading-nextline">CLIENT QUESTIONS</span>
      </div>
      <div className="questions-container">
      {faqData.map((item, index) => (
        <div key={index} className="question">
          <h2 className="question-title">{item.question}</h2>
          <p className="question-answer">{item.answer}</p>
        </div>
      ))}
      </div>
    </div>
  );
};
